import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import { withRouter } from 'react-router';

import styled, { css } from 'styled-components';
import mq from 'UIKit/Mq';
// import { ROLE } from '@/modules/User';
import navLinks from './NavLinks';
import NavMenuItem from './NavMenuItem';

// const { LEARNER, TEACHER } = ROLE;

// Styles

// StyledComponents
const NavStyled = styled.nav`
  overflow: auto;
  height: 100%;
  padding-top: 20px;
  ${mq.tabletHorizontal`
    position: fixed;
    z-index: 2;
    top: 0;
    bottom: 0;
    min-width: 270px;
    max-width: 300px;
    margin-top: 35px;
    transform:translateX(0)
    `};
  ${mq.tablet`
    width: 100%;
    margin-top: 35px;
    `};
  ${({ navCollapsed }) =>
    navCollapsed &&
    css`
      overflow: initial;
    `};
`;

const SidebarContent = ({ navCollapsed, user }) => {
  return (
    <NavStyled navCollapsed={navCollapsed}>
      <List>
        {navLinks.menu
          .filter(menu => menu.role.includes(user.role))
          .map((menu, index) => (
            <NavMenuItem
              menu={menu}
              type="menu"
              navCollapsed={navCollapsed}
              key={index}
            />
          ))}
      </List>
      <List>
        {navLinks.user.map((menu, index) => (
          <NavMenuItem
            menu={menu}
            type="user"
            navCollapsed={navCollapsed}
            key={index}
          />
        ))}
      </List>
    </NavStyled>
  );
};

SidebarContent.propTypes = {
  navCollapsed: PropTypes.any.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
});

export default withRouter(connect(mapStateToProps)(SidebarContent));
